export default __webpack_public_path__ + "static/media/check-circle-gray.c2c41764.svg";